import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	min-width: 100%;
	height: 100%;
	background: ${(props) => props.theme.white};
	padding: 1rem 0.8rem;
	border-radius: 8px;
	text-align: center;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	overflow: auto;
`;

export const HeaderFile = styled.div<{ canDownload?: boolean }>`
	display: flex;
	flex-direction: ${(props) => props.canDownload ? "row" : "column"};
	align-items: flex-start;
	justify-content: ${(props) => props.canDownload ? "space-between" : "flex-start"};
	gap: 0.4rem;
	background: ${(props) => props.theme.white};
	margin-bottom: 16px;
`;

export const TitleFile = styled.div`
	color: ${(props) => props.theme.grayDarker};
	font-size: 1rem;
	font-weight: bold;
`;
export const PreviewFile = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`;